<template>
  <div class="faq-article-content-wrapper">
    <div v-if="articleHeader">
      <div><p v-html="articleHeader"></p></div>
      <div class="faq-divider"></div>
    </div>
    <div
      v-for="(faq, i) in faqsData"
      :key="i"
      class="px-0"
      :class="showDivider(faqsData, i) ? 'faq-divider' : ''"
    >
      <div class="faq-wrapper py-4 pr-4">
        <knowledge-faq-collapsible :faq="faq" />
      </div>
    </div>
    <div v-if="articleFooter">
      <div class="faq-divider"></div>
      <div class="pt-3"><p v-html="articleFooter"></p></div>
    </div>
  </div>
</template>

<script>
import KnowledgeFaqCollapsible from "./KnowledgeFaqCollapsible";
import { mapGetters } from "vuex";

export default {
  name: "knowledge-faq-article-content",
  props: ["articleHeader", "articleFooter", "faqsData"],
  components: {
    KnowledgeFaqCollapsible,
  },
  created() {
    this.logFaqArticleVisit();
    this.checkRouteIsValid();
  },
  computed: {
    ...mapGetters(["articleContent"]),
  },
  methods: {
    logFaqArticleVisit() {
      if (this.articleContent && this.articleContent.name)
        this.$hhMixpanel.trackEvent(
          "FAQ article visited: " + this.articleContent.name
        );
    },
    checkRouteIsValid() {
      if (!(this.$route.name === "knowledge-article-faqs")) return;

      let routeFaqId = this.$route.params.faqId;
      let faqIds = this.faqsData.map((faq) => faq.id);

      if (!routeFaqId || !faqIds.includes(routeFaqId)) {
        this.$router.push({ name: "page-not-found" });
      }
    },
    showDivider(list, index) {
      if (list.length && list.length > 1) {
        let lastIndex = list.length - 1;
        return index === lastIndex ? false : true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style scoped>
.faqs-list-wrapper {
  border: 1px solid #b0b9c3;
}
.faq-divider {
  border-bottom: 1px solid #b0b9c3;
}
</style>



// WEBPACK FOOTER //
// src/components/knowledge-article/KnowledgeFaqArticleContent.vue